// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimIncentiveProgram from '@deere/cps-it.warranty-model-factory/lib/claim-incentive-program';

const ProgramNameDropDown = props =>
    <select
        {...props}
    >
        <option value=''/>
        {
            props.list.map(plan =>
                <option
                    key={plan.programName}
                    value={plan.programName}
                >
                    {`${plan.programName} - ${plan.programDescription}`}
                </option>
            )
        }
    </select>;

ProgramNameDropDown.displayName = 'ProgramNameDropDown';
ProgramNameDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(ClaimIncentiveProgram)).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};

export default ProgramNameDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/program-name-dropdown.js